import React from 'react';
import './Stat.scss';

export default function Stat ({ icon, value, metric, labels = [] }) {
    return (
        <div className='stat'>
            <div className='stat--icon'>
                {icon}
            </div>
            <div className='stat--content'>
                <div className='stat--content--data'>
                    {
                        value !== undefined ? (
                            <h3 className='stat--content--data--value'>
                                {value}
                            </h3>
                        ) : null
                    }
                    {
                        metric ? (
                            <span className='stat--content--data--metric'>
                                {metric}
                            </span>
                        ) : null
                    }
                </div>
                <div className='stat--content--labels'>
                    {labels.map((l, k) => <label key={k}>{l}</label>)}
                </div>
            </div>
        </div>
    );
};